export default __webpack_public_path__ + "static/16_36-12a40eed5675809ad01a8a28d453e6f9.png";